(function() {
  if (!customElements.get("image-and-text-toggle")) {
    class ImageAndTextToggle extends HTMLElement {
      constructor() {
        super();
        this.toggles = this.querySelectorAll("[data-toggle-index]");
        this.contents = this.querySelectorAll("[data-toggle-content]");
        this.activeContent = this.querySelector("[data-toggle-content]:not(.opacity-0)");
        this.activeIndex = 0;
        this.images = this.querySelectorAll("[data-toggle-image]");
        this.fallbackImage = this.querySelector("[data-fallback-image]");
        this.mediaContainer = this.querySelector("[data-natural-ratio]");
      }
      connectedCallback() {
        this.toggles.forEach(toggle => {
          toggle.addEventListener("click", () => {
            const index = parseInt(toggle.dataset.toggleIndex);
            if (index === this.activeIndex) return;
            this.switchToggle(index);
          });
        });
        if (this.mediaContainer) {
          const activeImage = this.querySelector("[data-toggle-image].is-active");
          this.applyNaturalRatio(activeImage);
        }
      }
      applyNaturalRatio(imageWrapper) {
        if (!this.mediaContainer) return;
        let source = imageWrapper;
        if (!source || !source.style.getPropertyValue("--aspect-ratio-desktop")) source = this.fallbackImage;
        if (!source) return;
        const desktop = source.style.getPropertyValue("--aspect-ratio-desktop");
        const mobile = source.style.getPropertyValue("--aspect-ratio-mobile");
        if (desktop) this.mediaContainer.style.setProperty("--aspect-ratio-desktop", desktop);
        if (mobile) this.mediaContainer.style.setProperty("--aspect-ratio-mobile", mobile);
      }
      switchToggle(index) {
        const oldToggle = this.querySelector(`[data-toggle-index="${this.activeIndex}"]`);
        const newToggle = this.querySelector(`[data-toggle-index="${index}"]`);
        const oldContent = this.querySelector(`[data-toggle-content="${this.activeIndex}"]`);
        const newContent = this.querySelector(`[data-toggle-content="${index}"]`);
        const oldImage = this.querySelector(`[data-toggle-image="${this.activeIndex}"]`);
        const newImage = this.querySelector(`[data-toggle-image="${index}"]`);
        if (oldToggle) oldToggle.classList.remove("is-active");
        if (newToggle) newToggle.classList.add("is-active");
        if (oldContent) oldContent.classList.remove("is-active");
        if (newContent) newContent.classList.add("is-active");
        if (oldImage) oldImage.classList.remove("is-active");
        if (newImage) newImage.classList.add("is-active");
        if (newImage && newImage.children.length > 0) this.fallbackImage?.classList.add("is-hidden"); else this.fallbackImage?.classList.remove("is-hidden");
        if (this.mediaContainer) this.applyNaturalRatio(newImage);
        this.activeIndex = index;
      }
    }
    customElements.define("image-and-text-toggle", ImageAndTextToggle);
  }
})();